import { Company, UpdateCompanyRequest } from '@/types/company';

import api, { handleError } from './axiosInstance';

const GET_COMPANY_ENDPOINT = (companyId: string) =>
  `https://api.vh3connect.io/api:xZQSDf6r/company/${companyId}`;

const UPDATE_COMPANY_ENDPOINT = (companyId: string) =>
  `https://api.vh3connect.io/api:xZQSDf6r/company/${companyId}`;

export const companyApi = {
  getCompany: async (companyId: string): Promise<Company | undefined> => {
    try {
      const { data } = await api.get<Company>(GET_COMPANY_ENDPOINT(companyId));

      return data;
    } catch (error) {
      handleError(error, 'company');
    }
  },

  updateCompany: async (
    companyId: string,
    updateData: UpdateCompanyRequest
  ): Promise<Company | undefined> => {
    try {
      const { data } = await api.patch<Company>(
        UPDATE_COMPANY_ENDPOINT(companyId),
        { data: updateData }
      );

      return data;
    } catch (error) {
      handleError(error, 'company');
    }
  },
};
